<template>
  <a-modal
    :title="dataForm.id ? '编辑分包单位' : '新增分包单位'"
    :visible="visible"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    width="50%"
    :keyboard="false"
    :maskClosable="false"
    @cancel="handleCancel"
    okText="保存"
    :getContainer="getContainer"
  >
    <div class="myForm">
      <a-form-model
        ref="ruleForm"
        :model="dataForm"
        :rules="rules"
        layout="horizontal"
      >
        <a-form-model-item prop="name" ref="name">
          <FormItem label="单位名称">
            <a-input
              size="large"
              v-model="dataForm.name"
              placeholder="请输入单位名称"
              @change="
                () => {
                  $refs.name.onFieldChange();
                }
              "
            />
          </FormItem>
        </a-form-model-item>
        <a-form-model-item prop="code" ref="code">
          <FormItem label="统一社会信用代码">
            <a-input
              size="large"
              v-model="dataForm.code"
              placeholder="请输入统一社会信用代码"
              @change="
                () => {
                  $refs.code.onFieldChange();
                }
              "
            />
          </FormItem>
        </a-form-model-item>
        <a-row :gutter="10">
          <a-col :span="12">
            <a-form-model-item prop="legal_person" ref="legal_person">
              <FormItem label="法人">
                <a-input
                  size="large"
                  v-model="dataForm.legal_person"
                  placeholder="请输入法人名称"
                  @change="
                    () => {
                      $refs.legal_person.onFieldChange();
                    }
                  "
                />
              </FormItem>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item
              prop="registered_capital"
              ref="registered_capital"
            >
              <FormItem label="注册资本">
                <a-input
                  size="large"
                  v-model="dataForm.registered_capital"
                  placeholder="请输入注册资本"
                  type="number"
                  suffix="万元"
                  @change="
                    () => {
                      $refs.registered_capital.onFieldChange();
                    }
                  "
                />
              </FormItem>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item prop="address" ref="address">
              <FormItem label="住所">
                <a-input
                  size="large"
                  v-model="dataForm.address"
                  placeholder="请输入单位住所"
                  @change="
                    () => {
                      $refs.address.onFieldChange();
                    }
                  "
                />
              </FormItem>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item prop="establish" ref="establish">
              <FormItem label="成立时间">
                <a-date-picker
                  placeholder="请选择成立时间"
                  mode="date"
                  size="large"
                  format="YYYY-MM-DD"
                  v-model="dataForm.establish"
                  :disabled-date="disabledDate"
                  style="width: 100%"
                  valueFormat="YYYY-MM-DD"
                  @change="
                    () => {
                      $refs.establish.onFieldChange();
                    }
                  "
                  :getCalendarContainer="(triggerNode) => triggerNode.parentNode"
                />
              </FormItem>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item prop="business_term" ref="business_term">
              <FormItem label="营业期限">
                <a-input
                  size="large"
                  v-model="dataForm.business_term"
                  placeholder="请输入营业期限"
                  type="number"
                  suffix="年"
                  @change="
                    () => {
                      $refs.business_term.onFieldChange();
                    }
                  "
                />
              </FormItem>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item prop="contacts" ref="contacts">
              <FormItem label="联系人姓名">
                <a-input
                  size="large"
                  v-model="dataForm.contacts"
                  placeholder="请输入联系人姓名"
                  @change="
                    () => {
                      $refs.contacts.onFieldChange();
                    }
                  "
                />
              </FormItem>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item prop="telephone" ref="telephone">
              <FormItem label="联系电话">
                <a-input
                  size="large"
                  v-model="dataForm.telephone"
                  placeholder="请输入联系电话"
                  @change="
                    () => {
                      $refs.telephone.onFieldChange();
                    }
                  "
                />
              </FormItem>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
  </a-modal>
</template>
  
<script>
import { addCompany, editCompany, companyInfo } from "@/request/company";
import FormItem from "@/components/FormItem/index";
import moment from "moment";
export default {
  components: { FormItem },
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 5 },
      wrapperCol: { span: 19 },
      treeData: [],
      dataForm: {
        id: "",
        name: "", //公司名称
        code: "", //统一社会信用代码
        legal_person: "", //法人
        registered_capital: "", //注册资本
        address: "", //住所
        establish: "", //成立日期
        business_term: "", //营业期限
        business_scope: "", //营业范围
        contacts: "", //联系人姓名
        telephone: "", //联系电话
      },
      bf: {},
      rules: {
        name: [
          { required: true, message: "请输入角色名称", trigger: "change" },
        ],
        code: [
          {
            required: false,
            message: "请输入统一社会信用代码",
            trigger: "change",
          },
        ],
        legal_person: [
          { required: false, message: "请输入法人名称", trigger: "change" },
        ],
        registered_capital: [
          {
            required: false,
            message: "请输入注册资本",
            trigger: "change",
          },
        ],
        address: [
          {
            required: false,
            message: "请输入公司住所",
            trigger: "change",
          },
        ],
        establish: [
          {
            required: false,
            message: "请选择成立日期",
            trigger: "change",
          },
        ],
        business_term: [
          {
            required: false,
            message: "请输入营业期限",
            trigger: "change",
          },
        ],
        contacts: [
          {
            required: false,
            message: "请输入联系人姓名",
            trigger: "change",
          },
        ],
        telephone: [
          {
            required: false,
            message: "请输入联系电话",
            trigger: "change",
          },
        ],
      },
    };
  },
  beforeMount() {
    this.bf = JSON.parse(JSON.stringify(this.dataForm));
  },
  methods: {
    init(id = "", project_id = "") {
      this.visible = true;
      if (id) {
        this.dataForm.id = id;
        this.getInfo();
      }
      this.dataForm.project_id = project_id;
    },
    disabledDate(current) {
      // Can not select days before today and today
      return current && current > moment().endOf("day");
    },
    getInfo() {
      companyInfo(this.dataForm.id).then((res) => {
        this.dataForm = { ...res.data };
      });
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          const fn = this.dataForm.id ? editCompany : addCompany;
          // return console.log(JSON.parse(JSON.stringify(this.dataForm)));
          fn(this.dataForm)
            .then((res) => {
              this.$message.success(
                this.dataForm.id ? "修改分包单位成功" : "新增分包单位成功"
              );
              this.handleCancel();
              this.$emit("ok");
            })
            .finally(() => {
              let a = setTimeout(() => {
                clearTimeout(a);
                this.confirmLoading = false;
              }, 500);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleCancel() {
      console.log("Clicked cancel button");
      this.$refs.ruleForm.resetFields();
      this.dataForm = JSON.parse(JSON.stringify(this.bf));
      this.visible = false;
    },
    //切换角色
    roleChange(e) {
      this.dataForm.role_id = e;
    },
    getContainer(){
      return document.getElementById("bodyContnet")
    }
  },
};
</script>
  
<style></style>